import { useQuery, useMutation } from "@tanstack/react-query";
import { WearablesService, SystemService, type GetApiGarminConnectionsResponse } from "@/lib/api_client";
import { getAuthHeaders } from "@/lib/api";

export type GarminConnection = GetApiGarminConnectionsResponse[number];

export const useGarminConnections = () =>
  useQuery({
    queryKey: ["garmin-connections"],
    queryFn: async () => {
      const res = await WearablesService.getApiGarminConnections({
        headers: getAuthHeaders(),
        query: { limit: 200 },
      });
      return res.data ?? [];
    },
    staleTime: 30_000,
  });

export const useGarminBackfill = () =>
  useMutation({
    mutationFn: async (opts: { authUserIds: string[]; days?: number }) => {
      const res = await WearablesService.postApiWearablesGarminBackfill({
        body: opts,
        headers: getAuthHeaders(),
      });
      if (!res.data) throw new Error("Backfill failed");
      return res.data as unknown as { enqueued: string[]; skipped: string[]; days: number };
    },
  });

export const useHrDistributionBackfill = () =>
  useMutation({
    mutationFn: async () => {
      const res = await SystemService.postApiSystemJobs({
        body: {
          worker: "backfill-hr-distribution-scan",
          args: {},
        },
        headers: getAuthHeaders(),
      });
      if (!res.data) throw new Error("HR distribution backfill failed");
      return { message: "HR distribution scan enqueued" };
    },
  });
